import React from 'react';
import Hero from '../Hero';
import AboutSection from '../Section/AboutSection';
import Banner from '../Section/BannerSection';
import Section from '../Section';
import FeaturesSection from '../Section/FeaturesSection';
import TestimonialSection from '../Section/TestimonialSection';
import FaqSection from '../Section/FaqSection';
import DepartmentSection from '../Section/DepartmentSection';
import { pageTitle } from '../../helpers/PageTitle';
import { examsData } from '../../data/exams';
const featureListData = [
  {
    iconSrc: '/images/home_1/compassion.svg',
    title: 'Empathie',
    subTitle:
      'Une maladie du cœur inquiète. Nous accueillons chaque patient avec écoute et disponibilité, pour une prise en charge claire, rassurante et humaine, du premier rendez-vous au suivi au long cours.',
  },
  {
    iconSrc: '/images/home_1/excellence.svg',
    title: 'Excellence',
    subTitle:
      'Diagnostic, prévention et traitements s’appuient sur une expertise cardiologique exigeante et un plateau technique adapté, afin de protéger durablement votre santé cardiovasculaire.',
  },
  {
    iconSrc: '/images/home_1/integrity.svg',
    title: 'Éthique',
    subTitle:
      'Nous pratiquons une médecine transparente : décisions expliquées, indications justifiées, intérêt du patient toujours prioritaire. Prévenir aujourd’hui pour mieux protéger demain.',
  },
  {
    iconSrc: '/images/home_1/respect.svg',
    title: 'Respect',
    subTitle:
      'Chaque parcours est unique. Nous respectons vos antécédents, votre rythme de vie et vos choix, pour un suivi cardiovasculaire personnalisé, sans précipitation ni standardisation inutile.',
  },
  {
    iconSrc: '/images/home_1/teamwork.svg',
    title: 'Pluridisciplinarité',
    subTitle:
      'Cardiologie, prévention des facteurs de risque et réadaptation cardiaque s’articulent en équipe, en lien avec vos autres soignants, pour une prise en charge globale et coordonnée.',
  },
];
const faqData = [
  {
    title: 'Quelle est l’adresse de l’ICVT ?',
    content:
      'L’adresse de l’ICVT est 20 Rue de Longchamp, 75116 Paris.',
  },
  {
    title: 'Quels sont les horaires d’ouverture de l’ICVT ?',
    content:
      'L’ICVT est ouvert :<br />Lundi : 09h00 - 20h00<br />Mardi : 09h00 - 20h00<br />Mercredi : 09h00 - 20h00<br />Jeudi : 09h00 - 20h00<br />Vendredi : 09h00 - 20h00<br />Samedi : 09h00 - 18h00.',
  },
  {
    title: 'Quels sont les moyens de paiement acceptés par l’ICVT ?',
    content:
      'L’ICVT accepte les moyens de paiement suivants : carte bancaire.',
  },
  {
    title: 'Est-ce que l’ICVT accepte la carte Vitale ?',
    content: 'Oui, l’ICVT accepte la carte Vitale.',
  },
  {
    title: 'Quelles sont les langues parlées à l’ICVT ?',
    content:
      'Les langues parlées à l’ICVT sont l’anglais et le français.',
  },
  {
    title: 'Est-ce que l’ICVT accepte de nouveaux patients ?',
    content: 'Oui, l’ICVT accepte de nouveaux patients.',
  },
];

export default function Home() {
  pageTitle('Home');
  return (
    <>
      <Hero
        title="Prévenir Aujourd'hui <br />Protéger Demain"
        subTitle="Institut CardioVasculaire Trocadero"
        bgUrl="/images/home_1/hero_bg.jpeg"
        imgUrl="/images/home_1/hero_img.png"
        infoList={[
          {
            title: 'Téléphone',
            subTitle: '+33 01 56 91 08 46',
            iconUrl: '/images/contact/icon_1.svg',
          },
          {
            title: 'Horaires',
            subTitle: 'Lun-Ven: 09:00-20:00h',
            iconUrl: '/images/departments/clock.svg',
          },
          {
            title: 'Adresse',
            subTitle: '20 Rue de Longchamp, 75116 Paris',
            iconUrl: '/images/icons/pin.svg',
          },
        ]}
        btnText="Prendre RV"
        btnUrl="https://www.doctolib.fr/cabinet-medical/paris/icvt"
      />
      {/* Start Feature Section */}
      <Section
        topMd={185}
        topLg={140}
        topXl={100}
        bottomMd={185}
        bottomLg={140}
        bottomXl={100}
      >
        <FeaturesSection sectionTitle="Nos valeurs" data={featureListData} />
      </Section>
      {/* End Feature Section */}
      {/* Start About Section */}
      <Section>
        <AboutSection
          imgUrl="/images/home_1/about.png"
          spiningImgUrl="/images/home_1/about_mini.svg"
          title="Patients internationaux"
          subTitle="ICVT PARIS"
          featureList={[
            {
              featureListTitle:
                'Votre santé cardiovasculaire, même loin de chez vous.',
              featureListSubTitle:
                'Que vous soyez en voyage d’affaires, en vacances ou simplement de passage à Paris, l’Institut Cardiovasculaire Trocadéro vous accueille pour une prise en charge cardiologique rapide, complète et personnalisée. Situé au cœur du 16ᵉ arrondissement, notre cabinet met à votre disposition un plateau technique moderne pour réaliser la majorité des examens cardiovasculaires sur place, dans un environnement confortable et accueillant.',
            },
          ]}
          btnText="En savoir plus"
          btnUrl="/patients-internationaux"
        />
      </Section>
      {/* End About Section */}
      {/* Start Departments Section */}
      <Section topMd={185} topLg={150} topXl={110}>
        <DepartmentSection
          sectionTitle="Examens réalisés"
          bgUrl="images/home_1/department_bg.svg"
          data={examsData}
        />
      </Section>

      {/* End Departments Section */}
      {/* Start Testimonial */}
      <Section
        topMd={185}
        topLg={140}
        topXl={100}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <TestimonialSection
          sectionTitle="Témoignages"
          sectionTitleDown="De nos patients"
        />
      </Section>
      {/* End Testimonial */}
      {/* Start Banner Section */}
      <Section>
        <Banner
          bgUrl="images/home_1/cta_bg.svg"
          imgUrl="images/home_1/cta_img.png"
          title="Protégez votre cœur dès aujourd’hui."
          subTitle="Prenez rendez-vous dès aujourd’hui pour un bilan cardiovasculaire personnalisé."
        />
      </Section>
      {/* End Banner Section */}
      {/* Start FAQ Section */}
      <Section topMd={190} topLg={145} topXl={105}>
        <FaqSection
          data={faqData}
          sectionTitle="Questions fréquentes"
          sectionTitleUp="FAQ"
        />
      </Section>
      {/* End FAQ Section */}
    </>
  );
}
